import { __require as r } from "../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js";
r();
